import { createContext } from 'react'

const MenuContext = createContext((_?: JSX.Element) => { })

export default MenuContext